module.exports = __webpack_public_path__ + "img/oc.659bc9a4.png";